let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8nnk4")).then(() => parcelRequire('7kfqR'));